import * as React from 'react';
import {Tooltip} from 'antd';

import {UserRequirementsInfo} from './userRequirementInfo';

import './styles.scss';

export function UserRequirementsTooltip({children}) {
  return (
    <Tooltip
      trigger="click"
      className="userRequirements"
      title={<UserRequirementsInfo />}
      getPopupContainer={trigger => trigger}
      placement="rightBottom"
    >
      {children}
    </Tooltip>
  );
}
